export interface Metadata {
    [key: string]: string;
}

export const metaDataGQL = `
    metadata
`;
